import React from 'react'

const UserPermission = (props) => {

    const { permission, handlePermissionType, handleCostingPermission, checkedPermissions, formValues } = props

    return (
        <>
            <div className='card mb-2'>
                <div className='card-header'>
                    <h2>Special Permission</h2>
                </div>
                <div className='card-body bg-white'>
                    <div className='row'>
                        <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 my-auto'>
                            <div className='d-flex mb-2 mt-3 flex-wrap'>
                                {permission?.map((item) => (
                                    <div class="form-group mb-0 mr-3">
                                        <input
                                            type="checkbox"
                                            name="specialPermissions"
                                            id={item?.value}
                                            onChange={handlePermissionType}
                                            value={checkedPermissions}
                                            checked={formValues?.specialPermissions?.includes(item?.value)}
                                            className='input-checkbox'
                                        />
                                        <label for={item?.value} className='mr-2 mb-0 check-box-label'>{item?.label}</label>
                                    </div>
                                ))}
                                <div className="form-group mb-0 mr-3">
                                    <input
                                        type="checkbox"
                                        id="canViewCostingOverride"
                                        checked={!!formValues.canViewCostingOverride}
                                        onChange={(e) => {
                                            handleCostingPermission(e);
                                        }}
                                        style={{ cursor: "pointer" }}
                                    />
                                    <label htmlFor="canViewCostingOverride">
                                        View costing override
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserPermission